"use strict";

var Ajv = require('ajv');

var mediaSchema = require('./mediaSchema');

var ajv = Ajv({
  allErrors: true
});
var validate = ajv.compile(mediaSchema);

var validateMedia = function validateMedia(mediaJson) {
  var isValid = validate(mediaJson);
  if (isValid) return true;
  return ajv.errorsText(validate.errors);
};

module.exports = validateMedia;